import React, { useEffect } from 'react';
import { DownloadIcon, XIcon } from 'lucide-react';
import type { DisclosureDocument } from '../types/disclosures';
import { pluralize } from '../utils/format';
interface DocumentPreviewModalProps {
  document: DisclosureDocument;
  onClose: () => void;
}
export function DocumentPreviewModal({
  document,
  onClose
}: DocumentPreviewModalProps) {
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [onClose]);
  return <div className="fixed inset-0 z-40 flex items-center justify-center p-4" data-id="element-87" data-mp="1g7q7vfymvaql">
      <div className="absolute inset-0 bg-slate-900/30 backdrop-blur-[1px]" onClick={onClose} aria-hidden="true" data-id="element-88" data-mp="1baq0n1q1s1xw" />
      <div role="dialog" aria-modal="true" aria-labelledby="preview-title" className="relative flex max-h-[88vh] w-full max-w-2xl flex-col overflow-hidden rounded-xl border border-slate-200 bg-white shadow-pop" data-id="element-89" data-mp="28qn45cu0msdb">
        <div className="flex items-start justify-between gap-3 border-b border-slate-100 px-5 py-4" data-id="element-90" data-mp="137s169vuukva">
          <div className="min-w-0" data-id="element-91" data-mp="pgx19n3c3e3u">
            <h2 id="preview-title" className="truncate text-[15px] font-semibold text-slate-900" data-id="element-92" data-mp="pfvc6ephgr34">
              {document.name}
            </h2>
            <p className="mt-0.5 text-[12.5px] text-slate-500" data-id="element-93" data-mp="fi7fvkc8bbiu">
              {document.category} · {pluralize(document.pages, 'page')}
            </p>
          </div>
          <div className="flex items-center gap-1" data-id="element-94" data-mp="kexx4azrsd5u">
            <button type="button" className="rounded-md p-1.5 text-slate-400 transition hover:bg-slate-100 hover:text-slate-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500" aria-label="Download document" data-id="element-95" data-mp="6i13y2w6ijls">
              <DownloadIcon className="h-4 w-4" data-id="element-96" data-mp="25uww4jnbodk8" />
            </button>
            <button type="button" onClick={onClose} className="rounded-md p-1.5 text-slate-400 transition hover:bg-slate-100 hover:text-slate-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500" aria-label="Close preview" data-id="element-97" data-mp="25s0yyxjatswu">
              <XIcon className="h-4 w-4" data-id="element-98" data-mp="1pg77tljn1zpl" />
            </button>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto bg-slate-100 px-6 py-6" data-id="element-99" data-mp="2n3pqbo33qg6s">
          <div className="mx-auto space-y-4" data-id="element-100" data-mp="2n2wew9t772ib">
            {Array.from({
            length: Math.min(document.pages, 3)
          }).map((_, index) => <div key={index} className="mx-auto w-full max-w-md rounded-md border border-slate-200 bg-white p-6 shadow-sm" data-id="element-101" data-mp="2ddmnyxa3bpvs" data-mpi={index}>
                <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-400" data-id="element-102" data-mp="28cp7qq8n55wx">
                  {document.name}
                </p>
                <div className="mt-4 space-y-2" data-id="element-103" data-mp="3137blth6vbbe">
                  {Array.from({
                length: 9
              }).map((__, line) => <div key={line} className="h-2 rounded bg-slate-100" style={{
                width: `${70 + line * 13 % 30}%`
              }} data-id="element-104" data-mp="38fwyzer68r4o" data-mpi={line} />)}
                </div>
                <p className="mt-6 text-[11px] text-slate-400" data-id="element-105" data-mp="3nbw3kff2o952">
                  Page {index + 1} of {document.pages}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
}